/* LinksRenderer.js */

"use strict";
const Registrations = require("../../../../../../../RegistrationNamespaces");
const _ = require("lodash");
const Steve = require("@gluenetworks/steve_core").getInstance();
// const _ = require('lodash');/widgets/childview/ChildViewRenderer
const childViewComponent = require("../../../../../../widgets/childview/ChildViewRenderer");
const policyDetailsView = require("../../../audit_policy_details/AuditPolicyDetailsViewComponent");

class LinksRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("links-column");
        this._rootElem.component = this._model;

        this._policyExecutionTimeIcon = document.createElement("actionable-icon-gl");
        this._policyExecutionTimeIcon.dataset.icon = "configdrift.audit_policy";
        this._policyExecutionTimeIcon.setAttribute("title", "Policy");

        this._executionAuditLogIcon = document.createElement("actionable-icon-gl");
        this._executionAuditLogIcon.dataset.icon = "common.log_link";
        this._executionAuditLogIcon.setAttribute("title", "Logs");

        this._targetDevicesListIcon = document.createElement("actionable-icon-gl");
        this._targetDevicesListIcon.dataset.icon = "common.target_link";
        this._targetDevicesListIcon.setAttribute("title", "Devices");

        this._resultsAuditIcon = document.createElement("actionable-icon-gl");
        this._resultsAuditIcon.dataset.icon = "common.results_link";
        this._resultsAuditIcon.setAttribute("title", "Results");

        this._rerunAuditIcon = document.createElement("actionable-icon-gl");
        this._rerunAuditIcon.dataset.icon = "configdrift.run_audit2";
        this._rerunAuditIcon.setAttribute("title", "Run Audit");

        this._registerListeners();
        this.render();
    }

    /* ******************************************
    /* START PRIVATE COMPONENT RENDERER METHODS
    /* ****************************************** */
    _shutdown() {
        return new Promise((resolve /*,reject*/) => {
            this._unregisterListeners();
            this._policyExecutionTimeIcon.remove();
            this._policyExecutionTimeIcon = undefined;
            this._executionAuditLogIcon.remove();
            this._executionAuditLogIcon = undefined;
            this._targetDevicesListIcon.remove();
            this._targetDevicesListIcon = undefined;
            this._resultsAuditIcon.remove();
            this._resultsAuditIcon = undefined;
            this._rerunAuditIcon.remove();
            this._rerunAuditIcon = undefined;
            this._model = undefined;
            this._rootElem.remove();
            this._rootElem = undefined;
            resolve();
        });
    }

    _registerListeners() {
        this._executionAuditLogIcon.addEventListener(
            "click",
            (this._onClickAuditLogIcon = this._onClickAuditLogIcon.bind(this))
        );
        this._policyExecutionTimeIcon.addEventListener(
            "click",
            (this._onClickExecutionTimeIcon = this._onClickExecutionTimeIcon.bind(this))
        );
        this._targetDevicesListIcon.addEventListener(
            "click",
            (this._onClickDevicesListIcon = this._onClickDevicesListIcon.bind(this))
        );
        this._resultsAuditIcon.addEventListener(
            "click",
            (this._onClickResultsAuditIcon = this._onClickResultsAuditIcon.bind(this))
        );
        this._rerunAuditIcon.addEventListener(
            "click",
            (this._onClickRerunAuditIcon = this._onClickRerunAuditIcon.bind(this))
        );
        this._model.on("SwitchView", (this._onSwitchView = this._onSwitchView.bind(this)));
        this._model.on("Links", (this._onLinks = this._onLinks.bind(this)));
    }

    _unregisterListeners() {
        this._executionAuditLogIcon.removeEventListener("click", this._onClickAuditLogIcon);
        this._policyExecutionTimeIcon.removeEventListener("click", this._onClickExecutionTimeIcon);
        this._targetDevicesListIcon.removeEventListener("click", this._onClickDevicesListIcon);
        this._resultsAuditIcon.removeEventListener("click", this._onClickResultsAuditIcon);
        this._rerunAuditIcon.removeEventListener("click", this._onClickRerunAuditIcon);
        this._model.removeListener("SwitchView", this._onSwitchView);
        this._model.removeAllListeners("Links");
    }

    /** navigate inside view tab */
    _switchView(switchTo, params) {
        const _params = Object.assign(
            {},
            {
                configExecutionEntity: this._model.getValue(),
                customFieldsEntityDef: _.get(
                    this._model,
                    "_parentModel._customFieldsEntityDef",
                    {}
                ),
                deviceEntityDef: _.get(this._model, "_parentModel._deviceEntityDef", {}),
            },
            params
        );
        this._model._gameEditor.setActiveView(
            switchTo,
            [
                {
                    value: {
                        fqn: Registrations.AUDIT_POLICY_EDITOR_VIEW_HISTORY,
                        viewState: {
                            configExecutionEntity: _params.configExecutionEntity,
                        },
                    },
                    content: "Audit Execution Summary",
                    left: {
                        arrow: {
                            direction: "left",
                        },
                    },
                },
            ],
            _params
        );
    }

    _onClickAuditLogIcon() {
        this._switchView(Registrations.AUDIT_POLICY_EDITOR_SUBVIEW_EXECUTION_LOG);
        // this.model._gameEditor._auditPolicyId = pid;
    }

    _onClickExecutionTimeIcon() {
        // this._switchView(Registrations.AUDIT_POLICY_EDITOR_SUBVIEW_DETAILS_VIEW);
        let pdview = new policyDetailsView(
            this.model._logger,
            this.model._gameEditor,
            this.model._parentModel._userSession,
            this.model._modalUserFeedback,
            this.model._steveIo,
            this.model._parentModel._deviceEntityDef,
            this.model._parentModel._customFieldsEntityDef,
            this.model._parentModel._siteEntityDef,
            this.model._parentModel._commandSetEntityDef,
            _.get(Steve.di.getRegistered("$teve.services.Git"), "registeredObj"),
            {},
            this.model._parentModel._tagsEntityDef,
            this._model.getValue().auditPolicy,
            true,
            true
        );
        this._childViewRenderer = new childViewComponent({
            data: pdview.renderer.rootElement,
            backLink: "Audit Summary",
            title: "Policy Details",
            childData: pdview,
            parentData: this._model,
            backButton: true,
        });

        return pdview.renderer.render();
    }

    _onClickDevicesListIcon() {
        this._switchView(Registrations.AUDIT_POLICY_EDITOR_SUBVIEW_TARGET_DEVICES_LIST);
    }

    _onClickResultsAuditIcon() {
        this._switchView(Registrations.AUDIT_POLICY_EDITOR_VIEW_RESULTS, {isSubView: true});
    }

    _onClickRerunAuditIcon() {
        this._model._runAudit._rerunAudit();
    }

    _onSwitchView(view, options) {
        this._switchView(Registrations[view], options);
    }

    /* *****************************************
    /* END PRIVATE COMPONENT RENDERER METHODS
    /* START PUBLIC COMPONENT RENDERER METHODS
    /* ***************************************** */
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        this._setLinks(this._model.getLinks());
        return Promise.resolve();
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    /* *****************************************
    /* END COMPONENT RENDERER METHODS
    /* START HANDLER METHODS
    /* ***************************************** */

    _onLinks(newVal) {
        this._setLinks(newVal);
    }

    /* *****************************************
    /* END HANDLER METHODS
    /* START PRIVATE API METHODS
    /* ***************************************** */

    _setLinks(newVal) {
        this._rootElem.innerHTML = "";

        this._rootElem.appendChild(this._policyExecutionTimeIcon);
        this._rootElem.appendChild(this._executionAuditLogIcon);
        this._rootElem.appendChild(this._targetDevicesListIcon);
        this._rootElem.appendChild(this._resultsAuditIcon);
        this._rootElem.appendChild(this._rerunAuditIcon);

        if (newVal.status === "UNSUCCESSFUL") {
            this._policyExecutionTimeIcon.setDisabled(true);
            this._executionAuditLogIcon.setDisabled(true);
            this._targetDevicesListIcon.setDisabled(true);
            this._resultsAuditIcon.setDisabled(true);
        } else {
            this._policyExecutionTimeIcon.setDisabled(false);
            this._executionAuditLogIcon.setDisabled(false);
            this._targetDevicesListIcon.setDisabled(false);
            this._resultsAuditIcon.setDisabled(false);
        }
        if (_.has(newVal, "auditPolicy")) {
            this._rerunAuditIcon.setDisabled(true);
        }
    }

    _hideViewActions() {}
    _showViewActions() {}
    _refreshGrid() {}
    _hideLeftFooterContainer() {}
    _showLeftFooterContainer() {}

    /* *****************************************
    /* END PRIVATE API METHODS
    /* ***************************************** */
}

module.exports = LinksRenderer;
